import React from 'react';
import { useTranslation } from 'react-i18next';

function Philosophy() {
  const { t } = useTranslation();
  
  const philosophyPoints = [
    { title: t('philosophy.embed.title'), description: t('philosophy.embed.description') },
    { title: t('philosophy.connect.title'), description: t('philosophy.connect.description') },
    { title: t('philosophy.act.title'), description: t('philosophy.act.description') },
    { title: t('philosophy.deliver.title'), description: t('philosophy.deliver.description') }
  ];

  return (
    <section className="section philosophy-section" id="philosophy">
      <div className="container">
        <span className="section-label">{t('philosophy.label')}</span>
        <p className="section-subtitle">{t('philosophy.subtitle')}</p>
        <h2 className="section-title">{t('philosophy.title')}</h2>

        <div className="philosophy-grid">
          <span className="philosophy-plus plus-top">+</span>
          <span className="philosophy-plus plus-bottom">+</span>
          <span className="philosophy-plus plus-left">+</span>
          <span className="philosophy-plus plus-right">+</span>
          {philosophyPoints.map((point, index) => (
            <React.Fragment key={point.title}>
              <div className="philosophy-box animate-on-scroll">
                <h3>{point.title}</h3>
                <p>{point.description}</p>
              </div>
            </React.Fragment>
          ))}
        </div>

        <div className="philosophy-tagline">
          {t('philosophy.statement')}
        </div>
      </div>
    </section>
  );
}

export default Philosophy;
